export default __webpack_public_path__ + "static/starbucks-af353a20824da7c68d958913d844d310.png";